import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { apiSectorsFetch } from '@/services/DataService';
import { setSectors, setLoading, setError, SectorsState } from '@/store/slices/data/sectorsSlice';
import useAuth from './useAuth';
import { useAppSelector } from '@/store';

const useSectorsFetch = () => {
    const dispatch = useDispatch();
    const { authenticated } = useAuth();
    const sectorsState = useAppSelector((state) => state.data.sectorsState)

    const fetchSectors = async () => {
        dispatch(setLoading(true));
        try {
            const response = await apiSectorsFetch();
            dispatch(setSectors(response.data[0]));
            dispatch(setLoading(false));
        } catch (error: any) {
            dispatch(setError(error.message));
            dispatch(setLoading(false));
        }
    };

    useEffect(() => {
        if (authenticated && sectorsState.sectors.length === 0) {
            fetchSectors();
        }
    }, [dispatch, authenticated, sectorsState.sectors.length]);

    return sectorsState as SectorsState;
};

export default useSectorsFetch;
